import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Universal Spinner component with multiple variants and sizes
 * Follows themeClasses.css design system
 */
const Spinner = ({
  size = 'md',
  variant: _variant = 'default',
  message = '',
  fullscreen = false,
  inline = false,
  className = ''
}) => {
  const loaderWrapClasses = `
    loader-wrap
    loader-${size}
    ${inline ? '' : 'mx-auto'}
    ${message && !inline ? 'mb-4' : ''}
    ${inline ? '' : className}
  `.trim().replace(/\s+/g, ' ');

  const textSizeClasses = {
    xs: 'text-compact-xs',
    sm: 'text-compact-sm',
    md: 'text-compact-base',
    lg: 'text-compact-lg',
    xl: 'text-lg'
  };

 // Fullscreen overlay variant
 if (fullscreen) {
 return (
 <div className="listener-modal-backdrop" style={{ zIndex: 'var(--z-modal)' }} role="status" aria-live="polite">
 <div className="listener-modal is-narrow text-center">
 <div className="listener-modal-body loader-modal-body">
 <div className={`loader-wrap loader-${size}`}>
   <div className="loader" aria-hidden />
 </div>
 {message && (
 <p className={`loader-caption text-text-primary ${textSizeClasses[size]} font-medium`}>
 {message}
 </p>
 )}
 </div>
 </div>
 </div>
 );
 }

 // Inline variant (for buttons, etc.)
 if (inline) {
 return (
 <div className={`inline-flex items-center gap-2 ${className}`}>
 <div className={loaderWrapClasses}>
   <div className="loader" aria-hidden />
 </div>
 {message && (
 <span className={`text-text-primary ${textSizeClasses[size]}`}>
 {message}
 </span>
 )}
 </div>
 );
 }

 // Default variant (centered, can be used in sections)
 return (
 <div className={`text-center ${className}`}>
 <div className={loaderWrapClasses}>
   <div className="loader" aria-hidden />
 </div>
 {message && (
 <div className={`text-text-secondary ${textSizeClasses[size]} mt-2`}>
 {message}
 </div>
 )}
 </div>
 );
};

// For backwards compatibility, keep LoadingSpinner as fullscreen variant
export const LoadingSpinner = ({ message, size = 'lg', variant = 'default' }) => {
  const { t } = useTranslation('common');
  const displayMessage = message ?? t('messages.loading');
  return <Spinner fullscreen size={size} message={displayMessage} variant={variant} />;
};

export default Spinner; 